meedy.controller('meedy.deviceListController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.deviceModel',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, deviceModel) {

        function setData() {
            $scope.devices = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 999;

            $scope.columns = [
                {
                    field: "deviceLabel",
                    displayName: $translate.instant('T.MEEDY.MODULE.DEVICE.DEVICE_LABEL')
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.DEVICE.ACTION'),
                    cellTemplate: 'meedy/application/view/app/settings/device/grid-templates/data-device-list-delete-device.html'
                }
            ];

            $scope.currentState = Constant.STATE.APP.MEEDY.SETTINGS.MOBILE_DEVICES;
            $scope.Constant = Constant;
            $scope.hideAddButton();
            $scope.hideBackButton();
            $scope.resetTitle();
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }
        function setListeners() {
            $scope.$on(Event.MEEDY.DEVICE.GET_ACTIVE_DEVICES.SUCCESS, function(event, dataPage) {
                $scope.devices = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            });

            $scope.$on(Event.MEEDY.DEVICE.DELETE_ACTIVE_DEVICE.SUCCESS, function(event, offices) {
                deviceModel.getActiveDevices($scope.criteria);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.deleteDevice = function(device) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.DEVICE.DEVICE_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    deviceModel.deleteActiveDevice(device.userName);
                }, function() {
                    return false;
                });
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            deviceModel.getActiveDevices($scope.criteria);
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
